export default __webpack_public_path__ + "static/media/ConveyorMk1.256.779d538a.png";